import { createAppReducer, apiReducerSwitch } from 'lib/redux/reducerUtils'
import { UPDATE_APPLE_PAY_AVAILABLE, UPDATE_GOOGLE_PAY_AVAILABLE, API_CALL_REQUEST, API_CALL_FAILURE, API_CALL_SUCCESS, TOGGLE_SHOW_MARGIN_IN_SPOOF_MODE, DISMISS_LUX_PLUS_FREE_PREVIEW_BANNER, HOTEL_CANCELLATION_PRICE_CHANGE_MODAL_SEEN, DISMISS_BETA_TRIP_BANNER } from 'actions/actionConstants'
import {
  FETCH_MERCHANT_FEE_CONFIG,
  FETCH_PAYTO_SUPPORTED_BANKS,
  FETCH_DEPOSIT_CONFIG,
  FETCH_PAYPAL_SETTINGS,
} from 'actions/apiActionConstants'

export const initialSystemState: App.SystemState = {
  appBannerCookie: false,
  customerPortalURL: '',
  originalCanonicalURL: '',
  headlessMode: false,
  canPayWithApplePay: false,
  canPayWithGooglePay: false,
  storeMode: false,
  referrer: '',
  device: {
    osName: '',
    browserName: '',
    deviceType: 'other',
  },
  rawUserAgentString: '',
  previewMode: false,
  merchantFeeConfigs: [],
  payToSupportedBanks: [],
  depositConfigs: undefined,
  payPalSettings: undefined,
  showMarginInSpoofMode: false,
  luxPlusFreePreviewBannerDismissed: false,
  hotelCancellationPriceChangeModalSeen: false,
  betaTripBannerDismissed: false,
}

const apiCalls = apiReducerSwitch<App.SystemState>({
  [FETCH_MERCHANT_FEE_CONFIG]: {
    request: () => ({
      merchantFeeConfigs: [],
    }),
    success: (_state, action) => ({
      merchantFeeConfigs: action.data,
    }),
  },
  [FETCH_PAYTO_SUPPORTED_BANKS]: {
    request: () => ({
      payToSupportedBanks: [],
    }),
    success: (_state, action) => ({
      payToSupportedBanks: action.data,
    }),
  },
  [FETCH_DEPOSIT_CONFIG]: {
    request: () => ({
      depositConfigs: undefined,
    }),
    success: (_state, action) => ({
      depositConfigs: action.data,
    }),
  },
  [FETCH_PAYPAL_SETTINGS]: {
    request: () => ({
      payPalSettings: undefined,
    }),
    success: (_state, action) => ({
      payPalSettings: action.data,
    }),
  },
})

export default createAppReducer<App.SystemState>(initialSystemState, {
  [API_CALL_REQUEST]: (state, action) => apiCalls(state, action),
  [API_CALL_FAILURE]: (state, action) => apiCalls(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiCalls(state, action),
  [UPDATE_APPLE_PAY_AVAILABLE]: (_state, action) => ({
    canPayWithApplePay: action.value,
  }),
  [UPDATE_GOOGLE_PAY_AVAILABLE]: (_state, action) => ({
    canPayWithGooglePay: action.value,
  }),
  [TOGGLE_SHOW_MARGIN_IN_SPOOF_MODE]: (state, action) => ({
    ...state,
    showMarginInSpoofMode: action.showMarginInSpoofMode,
  }),
  [DISMISS_LUX_PLUS_FREE_PREVIEW_BANNER]: (state) => ({
    ...state,
    luxPlusFreePreviewBannerDismissed: true,
  }),
  [HOTEL_CANCELLATION_PRICE_CHANGE_MODAL_SEEN]: (state) => ({
    ...state,
    hotelCancellationPriceChangeModalSeen: true,
  }),
  [DISMISS_BETA_TRIP_BANNER]: (state) => ({
    ...state,
    betaTripBannerDismissed: true,
  }),
})
